// @flow
import React, { Component } from "react";
import JournalIcon from "@material-ui/icons/Edit";
import PhotoIcon from "@material-ui/icons/PhotoCamera";
import MovieIcon from "@material-ui/icons/LocalMovies";
import MapIcon from "@material-ui/icons/AddLocation";

import { isLoggedInCust } from "../utils/session";

import {
    Container,
    ButtonText,
    JournalButton,
    PhotoButton,
    MovieButton,
    MapButton,
    Title
} from "./styled";

import { Mobile, Desktop } from "../styled";

type Props = {|
    session: Object,
    userInfo: Object,
    onShowPlotMap: Function,
    onShowWriteJournal: Function
|};

class UpdatePanel extends Component<Props> {
    render() {
        const { session, userInfo, onShowPlotMap, onShowWriteJournal } = this.props;
        isLoggedInCust(session, userInfo);
        return isLoggedInCust(session, userInfo) &&
            (userInfo[0].custUrl === "fay" || userInfo[0].custUrl === "mrb") ? (
            <Container>
                <Mobile>
                    <Title>Post an update:</Title>
                </Mobile>
                <JournalButton onClick={onShowWriteJournal}>
                    <JournalIcon />
                    <ButtonText>
                        <Desktop>Write </Desktop>
                        Journal
                    </ButtonText>
                </JournalButton>
                <PhotoButton href="https://www.getjealous.com/admin.php?action=uploadphotos">
                    <PhotoIcon />
                    <ButtonText>
                        <Desktop>Upload </Desktop>
                        Photo
                    </ButtonText>
                </PhotoButton>
                <MovieButton href="https://www.getjealous.com/admin.php?action=uploadmovie">
                    <MovieIcon />
                    <ButtonText>
                        <Desktop>Upload </Desktop>
                        Movie
                    </ButtonText>
                </MovieButton>
                <MapButton onClick={onShowPlotMap}>
                    <MapIcon />
                    <ButtonText>
                        <Desktop>Update </Desktop>
                        Location
                    </ButtonText>
                </MapButton>
            </Container>
        ) : (
            <div />
        );
    }
}

export default UpdatePanel;



// WEBPACK FOOTER //
// ./src/update-panel/view.js